<template>
  <div>
    <div class="wrapper">
      <van-tabs color="#108EE9" sticky>
        <van-tab title="产品详情">
          <ProductDetailInfo></ProductDetailInfo>
        </van-tab>
        <van-tab title="意向企业">
          <div v-if="entList && entList.length >0">
            <van-cell-group v-for="(item, index) in entList" :key="index" :name="index">
              <van-cell title="需求金额" :value="item.applyAmount" />
              <van-cell title="地址" :value="item.contactAddr" />
              <van-cell title="联系电话" :value="item.contactPhone" />
              <van-cell title="申请时间" :value="item.createdDate" />
              <van-cell title="企业名称" :value="item.entName" />
              <van-cell title="企业类型" v-if="item.entType == 1" value="企业、农专社 " />
              <van-cell title="企业类型" v-else-if="item.entType == 2" value="个体工商户" />
              <van-cell title="企业类型" v-else-if="item.entType == 3" value="社团、民非、基金会" />
              <van-cell title="企业类型" v-else-if="item.entType == 4" value="党群机关" />
              <van-cell title="企业类型" v-else-if="item.entType == 5" value="事业单位" />
              <van-cell title="企业类型" v-else-if="item.entType == 6" value="居委会、村委会" />
              <van-cell title="企业类型" v-else-if="item.entType == 7" value="律师事务所、分所" />
               <van-cell title="企业类型" v-else-if="item.entType == 7" value="宗教场所" />
              <van-cell v-else title="企业类型" value="其他组织" />
            </van-cell-group>
          </div>
          <div v-else>
            <van-divider>暂未查询到数据</van-divider>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { SSHJRBPQ012 } from "@/api/user";
import ProductDetailInfo from "./components/productDetailInfo";
export default {
  components: {
    ProductDetailInfo
  },
  data() {
    return {
      listItem: {}, // list详情的所有数据
      entList: [], // 产品意向企业数据
      productId: "",
      pageNum: 1,
      pageSize: 10,
      applyAmount: "", // 需求金额
      contactAddr: "", // 地址
      contactPhone: "", // 联系电话
      createdDate: "", // 申请时间
      entName: "", // 企业名称
      entType: "", //  企业类型
      // 1企业、农专社、个体工商户，2事业单位，3社团、民非、基金会，4政府机关，5个体(已废弃)，6村委会、居委会，7律师事务所，8军队，99其他组织
      json1: {
        "1": "企业、农专社、个体工商户",
        "2": "事业单位",
        "3": "社团 民非 基金会",
        "4": "政府机关",
        "5": "村委会、居委会",
        "6": "律师事务所",
        "7": "军队",
        "8": "其他组织"
      }
    };
  },
  computed: {
    sessionId() {
      return this.$store.state.user.sessionId;
    }
  },
  async created() {
    this.productId = this.$store.state.product.productListDetails.productId;
    this.listItem = this.$store.state.product.productListDetails;
    this.relevancy();
  },
  methods: {
    // 关联意向企业 接口
    relevancy() {
      SSHJRBPQ012({
        data: {
          productId: this.productId,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      })
        .then(res => {
          let result = res;
          if (result.resCode === "0000") {
            this.entList = result.data.paramPageInfo.list;
            this.userApplyFlag = false;
          } else {
            this.$toast.fail("fail" + result.resDesc);
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  padding-top: 10px;
  width: 100%;
  height: 100%;
  background: #f1f2f3;
  .custom-value {
    margin-right: 8px;
  }
}
</style>